import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { accountApi } from "./api/account";
import { userApi } from "./api/userapi";
import { RPApi } from "./api/rolesandpermission";
import { BranchApi } from "./api/branch";
import { StaffApi } from "./api/staff";
import { VideosApi } from "./api/Videos";
import { MealsApi } from "./api/meals";
import { PlanApi } from "./api/plan";
import { MemberApi } from "./api/member";
import { WorkoutApi } from "./api/workout";
import { AdminPlanApi } from "./api/adminplan";
import themeReducer from "./themeSlice"; 
import { themeApi } from "./api/custom_ui";
import { RequestedGym } from "./api/requested";
import { AppointmentApi } from "./api/appointmentApi";
import { VendorcatalogApi } from "./api/VendorcatalogApi";
import {VendorWarehouseApi} from "./api/VendorWarehouseApi";
import {AdminCatalogApi} from "./api/AdminCatalogApi";
export const store = configureStore({
    reducer:{
        [accountApi.reducerPath]: accountApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [RPApi.reducerPath]: RPApi.reducer,        
        [BranchApi.reducerPath]: BranchApi.reducer,   
        [StaffApi.reducerPath]:StaffApi.reducer,
        [VideosApi.reducerPath]:VideosApi.reducer,
        [PlanApi.reducerPath]:PlanApi.reducer,                            
        [MemberApi.reducerPath]:MemberApi.reducer, 
        [MealsApi.reducerPath]:MealsApi.reducer ,
        [WorkoutApi.reducerPath]:WorkoutApi.reducer,
        [AdminPlanApi.reducerPath]:AdminPlanApi.reducer,                  
        [themeApi.reducerPath]:themeApi.reducer,
        [RequestedGym.reducerPath]:RequestedGym.reducer,
        [AppointmentApi.reducerPath]:AppointmentApi.reducer,
        [VendorcatalogApi.reducerPath]:VendorcatalogApi.reducer,
        [VendorWarehouseApi.reducerPath]:VendorWarehouseApi.reducer,
        [AdminCatalogApi.reducerPath]:AdminCatalogApi.reducer,





        theme: themeReducer,
    },                           
                                   
    middleware:(getDefaultMiddleware)=> 
        getDefaultMiddleware().concat(accountApi.middleware).concat(userApi.middleware).concat(RPApi.middleware).concat(StaffApi.middleware).concat(VideosApi.middleware).concat(BranchApi.middleware).concat(PlanApi.middleware).concat(MemberApi.middleware).concat(MealsApi.middleware).concat(WorkoutApi.middleware).concat(AdminPlanApi.middleware).concat(themeApi.middleware).concat(RequestedGym.middleware).concat(AppointmentApi.middleware).concat(VendorcatalogApi.middleware).concat(VendorWarehouseApi.middleware).concat(AdminCatalogApi.middleware)
 
})

setupListeners(store.dispatch)